import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function TimestampConverterPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Timestamp Converter - JsonToonCraft",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free timestamp converter tool. Convert Unix timestamps to human-readable dates and vice versa. Supports milliseconds and seconds.",
    "featureList": [
      "Unix timestamp to date conversion",
      "Date to Unix timestamp conversion",
      "Milliseconds and seconds support",
      "Real-time current timestamp",
      "Multiple timezone support",
      "Instant conversion"
    ]
  };

  return (
    <>
      <SEO
        title="Timestamp Converter - Unix Timestamp to Date Converter | JsonToonCraft"
        description="Free timestamp converter tool. Convert Unix timestamps to human-readable dates and vice versa. Supports milliseconds and seconds. Real-time current timestamp display."
        keywords="timestamp converter, Unix timestamp, epoch converter, timestamp to date, date to timestamp, Unix time converter"
        canonicalUrl="https://jsontooncraft.com/dev-tools/timestamp-converter"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="timestamp" />
    </>
  );
}
